import { forwardRef } from "react";
import { StyledPaper } from "./styled";
import { IPaperProps } from "./types";

const Paper = forwardRef<HTMLDivElement, IPaperProps>(({children, ...props}, ref) => (
    <StyledPaper ref={ref} {...props}>
        {children}
    </StyledPaper>
))

Paper.displayName = "Paper";

export {Paper}